import _ from 'lodash'
import type {KeyWordSizeTypesArray, KeywordSize, KeywordSizeType} from '@wix/document-services-types'
import type {CssValue} from '../../constants'

const KEYWORD_SIZE_TYPES: KeyWordSizeTypesArray = ['auto', 'maxContent', 'minContent', 'unset', 'fit']
const KEYWORD_SIZE_TYPES_SET = new Set(KEYWORD_SIZE_TYPES)

const serialize = (val: any): CssValue | undefined =>
    _.isString(val?.type) && KEYWORD_SIZE_TYPES_SET.has(val.type as KeywordSizeType) ? val.type : undefined
const deserialize = (rule: CssValue): KeywordSize | undefined =>
    KEYWORD_SIZE_TYPES_SET.has(rule as KeywordSizeType) ? {type: rule as KeywordSizeType} : undefined

export default {
    serialize,
    deserialize
}
